<template>
  <el-table-column
    :label="label"
    :prop="prop"
    class-name="aircraft-weight-type-name"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <el-tag
        :type= actionTypeColor(scope.row.aircraft_weight_type_name)
        disable-transitions>
        {{scope.row.aircraft_weight_type_name}}
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '機種重量区分'
    },
    prop: {
      type: String,
      default: 'aircraft_weight_type_name'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    actionTypeColor (aircraftWeightTypeName) {
      if (aircraftWeightTypeName === '50t超') {
        return 'danger'
      }
      if (aircraftWeightTypeName === '50t以下') {
        return 'success'
      }
      if (aircraftWeightTypeName === '20t以下') {
        return ''
      }
    }
  }

}

</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.aircraft-weight-type-name {
      width: 12em;
    }
  }
  .el-tag {
    width: 5.5em;
    text-align:center
  }
}
</style>
